import ScrollReveal from "@/components/ScrollReveal";
import { resolveImageUrl } from "@/lib/api";

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 relative">
            <ScrollReveal direction="left" delay={100}>
              <div className="relative">
                <div className="absolute -top-6 -left-6 w-32 h-32 rounded-full bg-primary-100/70 -z-10"></div>
                <div className="absolute -bottom-6 -right-6 w-40 h-40 rounded-full bg-accent-100/60 -z-10"></div>
                <div className="rounded-lg overflow-hidden border border-background-200 w-full h-[520px] md:h-[600px]">
                  <img
                    src={resolveImageUrl("/uploads/home-about.jpg")}
                    alt="우공이산 대표 인물 사진"
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                <div className="absolute -bottom-8 left-6 md:-left-8 bg-background-50 rounded-lg border border-background-200 px-6 py-5 max-w-xs">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center">
                      <i className="ri-award-line text-background-50 text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <div className="font-heading text-foreground-950 text-xl font-bold">
                        15년+
                      </div>
                      <div className="text-foreground-600 text-xs">
                        산림 파쇄 현장 경력
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>

          <div className="lg:col-span-7">
            <ScrollReveal direction="up" delay={150}>
              <div className="inline-flex items-center gap-2 text-primary-700 text-xs tracking-[0.3em] uppercase font-medium mb-5">
                <span className="w-8 h-px bg-primary-500"></span>
                About Ugongisan
              </div>
              <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
                우공이산(愚公移山),
                <br />
                <span className="text-primary-700">한 걸음의 힘</span>을 믿습니다.
              </h2>
              <p className="mt-8 text-foreground-700 text-base md:text-lg leading-relaxed">
                &ldquo;오랜 시간이 걸려도 꾸준히 노력해 나간다면 결국엔 뜻을
                이룰 수 있다&rdquo;는 <strong className="text-foreground-950">우공이산</strong>의
                뜻을 마음에 담고, 산림 자원 순환의 한 축을 담당하는 회사가
                되기를 바라며 오늘도 현장을 지킵니다.
              </p>
              <p className="mt-4 text-foreground-700 text-base md:text-lg leading-relaxed">
                원목칩, 가지칩, 뿌리 파쇄까지 &mdash; 크고 거친 자원에 시간을
                들여 정성껏 손을 대는 것이 우리의 방식입니다.
              </p>
            </ScrollReveal>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">
              {[
                {
                  icon: "ri-shield-check-line",
                  title: "품질에 대한 원칙",
                  desc: "요구 스크린 사이즈에 맞춘 균일한 원목칩과 가지칩 품질을 약속합니다.",
                },
                {
                  icon: "ri-truck-line",
                  title: "전국 현장 대응",
                  desc: "경상권을 중심으로 전국 임지·건설 현장 파쇄 작업을 유연하게 진행합니다.",
                },
                {
                  icon: "ri-leaf-line",
                  title: "친환경 자원 순환",
                  desc: "임지 부산물, 벌목재를 유효 자원으로 되돌리는 순환 파쇄를 지향합니다.",
                },
                {
                  icon: "ri-customer-service-2-line",
                  title: "투명한 상담",
                  desc: "물량·현장 조건에 맞는 견적과 일정 안내를 사전에 명확히 제공합니다.",
                },
              ].map((f, i) => (
                <ScrollReveal key={f.title} direction="up" delay={200 + i * 120}>
                  <div className="p-5 rounded-lg bg-background-100/70 border border-background-200/70 hover:border-primary-300 transition-colors shadow-sm">
                    <div className="w-10 h-10 rounded-md bg-primary-500/10 flex items-center justify-center mb-3">
                      <i className={`${f.icon} text-primary-700 text-lg w-5 h-5 flex items-center justify-center`}></i>
                    </div>
                    <div className="font-heading font-semibold text-foreground-950 text-lg">
                      {f.title}
                    </div>
                    <p className="mt-1 text-foreground-600 text-sm leading-relaxed">
                      {f.desc}
                    </p>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}